import { render, staticRenderFns } from "./myNeeds.vue?vue&type=template&id=69facd7c&scoped=true&"
import script from "./myNeeds.vue?vue&type=script&lang=js&"
export * from "./myNeeds.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69facd7c",
  null
  
)

export default component.exports